// Окно помощника — ЕДИНСТВЕННАЯ его поверхность в кабинете (`ПРАВИЛА.md`, раздел 1.1).
//
// Открывается только из палитры (Ctrl+K), строкой «Спросить». Своего входа у окна больше нет,
// и это не потеря, а исправление: до 04.09.2026 сочетание Ctrl+K вело сюда напрямую, то есть
// одно и то же поле спрашивало про деньги и не умело открыть ни одного экрана. Человек,
// набравший в нём «ведомости», не получал ничего.
//
// Вопрос приходит снаружи уже набранным и задаётся сам: человек написал его в палитре и уже
// нажал Enter. Второе нажатие «Спросить» здесь было бы переспросом на действие, которое
// ничего не портит.
//
// Отдельного экрана чата с моделью в системе нет и не будет: тз относит его к будущим
// расширениям.

import { RiSparkling2Line } from '@remixicon/react';

import * as Modal from '@/shared/ui/modal';

import { AssistantBar } from './AssistantBar';

export function AssistantDialog({
  вопрос,
  закрыть,
}: {
  /** `null` — окно закрыто. Пустая строка — открыто без заданного вопроса. */
  вопрос: string | null;
  закрыть: () => void;
}) {
  return (
    <Modal.Root
      open={вопрос !== null}
      onOpenChange={(открыто) => {
        if (!открыто) {
          закрыть();
        }
      }}
    >
      <Modal.Content className='max-w-prose'>
        <Modal.Header
          icon={RiSparkling2Line}
          title='Спросить про деньги'
          description='Вопрос словами — ответ числом из базы. Считает система, модель только формулирует.'
        />
        <Modal.Body>
          {/* Ключ по вопросу: новый вопрос ИЗ ПАЛИТРЫ поднимает окно с чистым состоянием.
              Вопросы, заданные внутри окна, состояние не сбрасывают — иначе разговор («а за
              июнь?») терял бы прошлые реплики на каждом ходу и не работал бы вовсе. */}
          <AssistantBar key={вопрос ?? ''} начальныйВопрос={вопрос ?? ''} наПереход={закрыть} />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}
